export const PWA_INSTALL_GUIDES = {
  desktop: {
    label: 'رایانه',
    icon: 'solar:laptop-3-bold-duotone',
    title: 'نصب روی ویندوز، لینوکس یا macOS',
    description: 'در مرورگرهای Chrome یا Edge، رادو به‌صورت یک برنامه مستقل نصب می‌شود.',
    steps: [
      {
        title: 'رادو را باز نگه دارید',
        description: 'سامانه را با نشانی امن سازمان یا localhost باز کنید.',
        icon: 'solar:window-frame-bold-duotone',
      },
      {
        title: 'فرمان نصب را انتخاب کنید',
        description: 'روی «نصب رادو» بزنید یا نماد نصب را در نوار نشانی مرورگر انتخاب کنید.',
        icon: 'solar:download-minimalistic-bold-duotone',
      },
      {
        title: 'نصب را تأیید کنید',
        description: 'پس از تأیید، رادو از دسکتاپ، منوی Start یا Dock در دسترس است.',
        icon: 'solar:check-circle-bold-duotone',
      },
    ],
  },
  android: {
    label: 'اندروید',
    icon: 'solar:smartphone-2-bold-duotone',
    title: 'نصب روی تلفن و تبلت اندرویدی',
    description: 'برای بهترین نتیجه از Chrome یا مرورگر سازگار با نصب PWA استفاده کنید.',
    steps: [
      {
        title: 'منوی مرورگر را باز کنید',
        description: 'در Chrome، منوی سه‌نقطه بالای صفحه را لمس کنید.',
        icon: 'solar:menu-dots-circle-bold-duotone',
      },
      {
        title: 'نصب برنامه را بزنید',
        description: 'گزینه «نصب برنامه» یا «افزودن به صفحه اصلی» را انتخاب کنید.',
        icon: 'solar:add-square-bold-duotone',
      },
      {
        title: 'به صفحه اصلی بروید',
        description: 'نماد رادو کنار سایر برنامه‌ها قرار می‌گیرد و تمام‌صفحه اجرا می‌شود.',
        icon: 'solar:home-smile-angle-bold-duotone',
      },
    ],
  },
  ios: {
    label: 'آیفون و آیپد',
    icon: 'solar:smartphone-bold-duotone',
    title: 'افزودن رادو به صفحه اصلی iOS',
    description: 'در iPhone و iPad نصب از طریق مرورگر Safari انجام می‌شود.',
    steps: [
      {
        title: 'صفحه را در Safari باز کنید',
        description: 'اگر از مرورگر دیگری استفاده می‌کنید، نشانی رادو را در Safari باز کنید.',
        icon: 'solar:compass-big-bold-duotone',
      },
      {
        title: 'اشتراک‌گذاری را انتخاب کنید',
        description: 'دکمه اشتراک‌گذاری Safari را بزنید و فهرست عملیات را باز کنید.',
        icon: 'solar:upload-minimalistic-bold-duotone',
      },
      {
        title: 'افزودن به صفحه اصلی',
        description: 'گزینه Add to Home Screen و سپس Add را انتخاب کنید.',
        icon: 'solar:home-add-bold-duotone',
      },
    ],
  },
};

export function detectPwaInstallPlatform() {
  if (typeof navigator === 'undefined') return 'desktop';

  const userAgent = navigator.userAgent || '';
  const isIpadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  if (/iPad|iPhone|iPod/i.test(userAgent) || isIpadOs) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';

  return 'desktop';
}
